export default __webpack_public_path__ + "static/typography-image-j-a058a449803f5147b1c10bc6f2c0d2becf79cd025a4a7d2b866cfab193cc7367.png";